module.exports = __webpack_public_path__ + "static/img/equip-2.75bac1da.png";